import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import "./cmd-banner.scss";

const ComunidadBanner = (props: ReferenciaContenido) => {

    return (
      <>
        <div className="m-cmd-banner">
          <div className="m-cmd-banner__container">
            <div className="m-cmd-banner__container__left">
                <div className="m-cmd-banner__container__left__title">{props.tituloGeneral}</div>
                <div className="m-cmd-banner__container__left__description">{props.descripcion.json.content[0].content[0].value}</div>
            </div>
            <div className="m-cmd-banner__container__right">
              <img src={props.imagenPrincipal.file.url} />
            </div>
          </div>
        </div>
      </>
    );

}

export default ComunidadBanner;